import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as moment from 'moment';

@Injectable()
export class DataBaseService {
   urlDataBase: any = "https://lzu9u9n85a.execute-api.sa-east-1.amazonaws.com/v1/api";
   urlSite:any = "https://app.vivamax.com.br"
   apiDoc24: any = "https://sk2ii4laei.execute-api.sa-east-1.amazonaws.com/v1/doc24";

   apiVindi:any = "https://data.mongodb-api.com/app/database-msxfu/endpoint/vindi/vindi?";
   apiEmailBoasVindas:any = "https://data.mongodb-api.com/app/database-msxfu/endpoint/enviarboasvindas";


   apiSorte:any = this.urlDataBase+'/sorte';
   apiUsuarios:any = this.urlDataBase+'/usuarios';
   apiAssociados:any = this.urlDataBase+'/associados';
   apiCredenciados:any = this.urlDataBase+'/credenciados';
   apiFinanceiro:any = this.urlDataBase+'/financeiro';
   apiContasReceber:any = this.urlDataBase+'/contas-receber';
   apiPlanos:any = this.urlDataBase+'/planos';
   apiSubContratos:any = this.urlDataBase+'/subcontratos';
   apiLogs:any = this.urlDataBase+'/logs';
   apiConfiguracoes:any = this.urlDataBase+'/configuracoes';
   apiFornecedores:any = this.urlDataBase+'/fornecedores';
   apiFavorecidos:any = this.urlDataBase+'/favorecidos';
   apiCaixaVindi:any = this.urlDataBase+'/caixaVindi';
   apiReceberVindi:any = this.urlDataBase+'/receberVindi';
   apiFormularios:any = this.urlDataBase+'/formularios';
   apiEmpresas:any = this.urlDataBase+'/empresas';
   apiFaturamento:any = this.urlDataBase+'/faturamento';
   apiCelesc:any = this.urlDataBase+'/celesc';
   apiCargos:any = this.urlDataBase+'/cargos';
   apiProgramacao:any = this.urlDataBase+'/programacao';
   apiProgramacaoLogs:any = this.urlDataBase+'/proglogs';
   apiCentroCusto:any = this.urlDataBase+'/centroCusto';
   apiComissoes:any = this.urlDataBase+'/comissoes';
   apiMetricas:any = this.urlDataBase+'/metricas';
   apiVendas:any = this.urlDataBase+'/vendas';
   permissaoExcluirAssociado:any = "";
   tipoUsuario:any = "";
   usuario:any = "";
   todasFormasPagamento:any = [];
   cargos:any = [];
   configuracoes:any = [];
   idCargo:any = "";
   emails:any = [];
   motivosAtendimento:any = [];

   constructor(public http:HttpClient){
    window.addEventListener("load", () => {
    this.getUsuarioById(localStorage.getItem('idUserVivamax')).subscribe((u:any) => {
      if(u){
        this.permissaoExcluirAssociado = u.excluirAssociado;
        this.tipoUsuario = u.tipo;
        this.usuario = u;
      }
      this.getCargos().subscribe((data:any) => {
        this.cargos = data[0].cargos;
        this.idCargo = data[0]._id;
        this.getConfigs().subscribe((z:any) => {
          this.configuracoes = z;
          this.todasFormasPagamento = z[5].pagamentos;
          this.motivosAtendimento = z[26].motivosAtendimento
          this.emails = z[23].emails;
        })
      })
     });
   })  
  }

  getDataHoje() {
    return moment().format('yyyy-MM-DD');
  }

  getHora(): string {
    let jsonDate = new Date().toJSON();
    return new Date(jsonDate).toLocaleTimeString();
  }

  getID(): string {
    let id: any = Math.random().toString(36).slice(-8);
    return id;
  }
  
  sendEmail(email:any,assunto:any,corpo:any){
    return this.http.get(this.urlSite+'/sendEmail.php?email='+email+'&assunto='+assunto+'&corpo='+corpo);
  }

  enviarForm(id:any,imagedata:any){
    let url = this.urlSite+'/upload-formulario.php?id='+id;
    return this.http.post(url, imagedata);
  }

  removeDoc(fullUrl){
    let path = fullUrl.split('br/')[1];
    let url = this.urlSite+'/delete-doc.php?path='+path;
    return this.http.post(url,{});
  }

  enviarDocUser(imagedata:any){
    let url = this.urlSite+'/upload-doc-user.php';
    return this.http.post(url, imagedata);
  }

  enviarContrato(imagedata:any){
    let url = this.urlSite+'/upload-contrato.php';
    return this.http.post(url, imagedata);
  }

  enviarSubContrato(imagedata:any){
    let url = this.urlSite+'/upload-subcontrato.php';
    return this.http.post(url, imagedata);
  }

  enviarBoletoEmpresa(imagedata:any){
    let url = this.urlSite+'/upload-boleto-empresa.php';
    return this.http.post(url, imagedata);
  }

  enviarBoletoSubContrato(imagedata:any){
    let url = this.urlSite+'/upload-boleto-subcontrato.php';
    return this.http.post(url, imagedata);
  }

  enviarDocAssociado(imagedata:any){
    let url = this.urlSite+'/upload-doc-associado.php';
    return this.http.post(url, imagedata);
  }

  enviarDocCancelamento(imagedata:any){
    let url = this.urlSite+'/upload-doc-cancelamento.php';
    return this.http.post(url, imagedata);
  }

  enviarDocFinanceiro(imagedata:any){
    let url = this.urlSite+'/upload-doc-financeiro.php';
    return this.http.post(url, imagedata);
  }

  enviarDocFornecedor(imagedata:any){
    let url = this.urlSite+'/upload-doc-fornecedor.php';
    return this.http.post(url, imagedata);
  }

  enviarDocCredenciado(imagedata:any){
    let url = this.urlSite+'/upload-doc-credenciados.php';
    return this.http.post(url, imagedata);
  }

  enviarDocEmpresa(imagedata:any){
    let url = this.urlSite+'/upload-doc-empresas.php';
    return this.http.post(url, imagedata);
  }

  enviarDocVendas(imagedata:any){
    let url = this.urlSite+'/upload-doc-vendas.php';
    return this.http.post(url, imagedata);
  }

  enviarDocSinistro(imagedata:any){
    let url = this.urlSite+'/upload-doc-sinistro.php';
    return this.http.post(url, imagedata);
  }

  enviarDocSinistroDep(imagedata:any){
    let url = this.urlSite+'/upload-doc-sinistro-dep.php';
    return this.http.post(url, imagedata);
  }

  enviarDocSinistroDepExtra(imagedata:any){
    let url = this.urlSite+'/upload-doc-sinistro-depExtra.php';
    return this.http.post(url, imagedata);
  }

  getCep(cep:any){
    return this.http.get('https://viacep.com.br/ws/'+cep+'/json/');
  }

  getCpfs(url:any){
    return this.http.get(url);
  }
  
  getFormularios(){
    return this.http.get(this.apiFormularios);
  }

  getProgramacoes(){
    return this.http.get(this.apiProgramacao);
  }

  getComissoes(){
    return this.http.get(this.apiComissoes);
  }
  
  getAssociados(){
    return this.http.get(this.apiAssociados);
  }

  getSorte(){
    return this.http.get(this.apiSorte);
  }

  getAllFavorecidos(){
    return this.http.get(this.apiFavorecidos);
  }

  getCredenciados(){
    return this.http.get(this.apiCredenciados)
  }

  getAllUsuarios(){
    return this.http.get(this.apiUsuarios)
  }

  getCentrosCusto(){
    return this.http.get(this.apiCentroCusto);
  }

  getCargos(){
    return this.http.get(this.apiCargos);
  }

  getSubContratos(){
    return this.http.get(this.apiSubContratos);
  }

  getCaixaVindi(){
    return this.http.get(this.apiCaixaVindi);
  }

  getReceberVindi(){
    return this.http.get(this.apiReceberVindi);
  }  

  getContasById(id:any){
    return this.http.get(this.apiFinanceiro+'/'+id);
  }

  getAssociadosById(id:any){
    return this.http.get(this.apiAssociados+'/'+id);
  }

  getCredenciadosById(id:any){
    return this.http.get(this.apiCredenciados+'/'+id);
  }
  getUsuarioById(id:any){
    return this.http.get(this.apiUsuarios+'/'+id);
  }

  getFornecedorById(id:any){
    return this.http.get(this.apiFornecedores+'/'+id);
  }
  getSubContratosById(id:any){
    return this.http.get(this.apiSubContratos+'/'+id);
  }

  getPlanosById(id:any){
    return this.http.get(this.apiPlanos+'/'+id);
  }

  getEmpresasById(id:any){
    return this.http.get(this.apiEmpresas+'/'+id);
  }
  
   getAnexosCredenciadosById(id:any){
    return this.http.get(this.apiCredenciados+'/'+id+'?project={"anexos":1}');
  }
  
  getProgramacoesAnos(array:any){
    return this.http.get(this.apiProgramacao+'?sort={"ano":1}&project={'+array+'}');
  }

  getEmpresasComissao(array:any){
    return this.http.get(this.apiEmpresas+'?sort={"fantasiaEmpresa":1}&project={'+array+'}');
  }

  getAllFornecedores(){
    return this.http.get(this.apiFornecedores+'?sort={"razaoSocial":1}')
  }

  getEmpresas(){
    return this.http.get(this.apiEmpresas+'?sort={"fantasiaEmpresa":1}')
  }

  getConfigs(){
    return this.http.get(this.apiConfiguracoes+'?sort={"_id":1}');
  }

  getMetricas(){
    return this.http.get(this.apiMetricas+'?sort={"data":-1}'); 
  }

  getTodosPlanos(){
    return this.http.get(this.apiPlanos+'?sort={"empresaOrigem":-1,"tipo":-1,"nome":1}');
  }

  getPlanosComissao(array:any){
    return this.http.get(this.apiPlanos+'?sort={"empresaOrigem":-1,"tipo":-1,"nome":1}&project={'+array+'}');
  }  
 
  getDependenteByCpf(cpf:any){
    return this.http.get(this.apiAssociados+'?filtro={"dependentes.cpf":"'+cpf+'"}');
  }

  getDependenteExtraByCpf(cpf:any){
    return this.http.get(this.apiAssociados+'?filtro={"dependentesExtra.cpf":"'+cpf+'"}');
  }

   getLogsProgramacao(ano:any){
    return this.http.get(this.apiProgramacaoLogs+'?filtro={"anoProg":"'+ano+'"}&sort={"data":1,"hora":-1}');
  }

  getComissoesByData(mes:any){
    return this.http.get(this.apiComissoes+'?filtro={"mesComissao":"'+mes+'"}');
  }

  getComissoesByDataVendedor(mes:any,vendedor:any){
    return this.http.get(this.apiComissoes+'?filtro={"mesComissao":"'+mes+'","vendedor":"'+vendedor+'"}');
  }

  getProgramacaoByAno(ano:any){
    return this.http.get(this.apiProgramacao+'?filtro={"ano":"'+ano+'"}');
  }

  getLoginByUsuario(mail:any, pwd:any){
    return this.http.get(this.apiUsuarios+'?filtro={"email":"'+mail+'","pwd":"'+pwd+'"}')
  }

  getLoginByUsuarioProjection(mail:any, pwd:any,array:any){
    return this.http.get(this.apiUsuarios+'?filtro={"email":"'+mail+'","pwd":"'+pwd+'","situacao":{"$not":{"$regex":"DEMITIDO","$options":"i"}}}&project={'+array+'}')
  }

    getAssociadosByPlano(plano:any){
    return this.http.get(this.apiAssociados+'?filtro={"plano":{"$regex":"'+plano+'","$options":"i"}}&project={"plano":1,"nome":1,"numSorte":1}&sort={"_id":-1}');
  }

  getAllUsuariosComTarefas(){
    return this.http.get(this.apiUsuarios+'?filtro={"$or":[{"situacao":"EFETIVADO"},{"situacao":"EXPERIÊNCIA"}]}&sort={"nome":1}')
  }
  
  getAllUsuariosAtivos(){
    return this.http.get(this.apiUsuarios+'?filtro={"situacao":{"$not":{"$regex":"DEMITIDO","$options":"i"}}}&sort={"nome":-1}')
  }

  getUsuariosComercial(){
    return this.http.get(this.apiUsuarios+'?filtro={"colaboradorComercial":true,"situacao":{"$not":{"$regex":"DEMITIDO","$options":"i"}}}&sort={"nome":1}')
  }

  getUsuariosComercialComissao(array:any){
    return this.http.get(this.apiUsuarios+'?filtro={"colaboradorComercial":true,"situacao":{"$not":{"$regex":"DEMITIDO","$options":"i"}}}&sort={"nome":1}&project={'+array+'}');
  }

  getSorteLivre(){
    return this.http.get(this.apiSorte+'?filtro={"usado":false}');
  }

  getAssociadoByCpfAll(cpf:any){
    return this.http.get(this.apiAssociados+'?filtro={"cpf":"'+cpf+'"}&sort={"empresa":-1}');
  }

  getAssociadosByAno(ano:any){
    return this.http.get(this.apiAssociados+'?filtro={"dataAdesao":{"$gte":"'+ano+'-10-01","$lte":"'+ano+'-12-31"}}');
  }

  getAssociadosByVendedor(vendedor:any){
    return this.http.get(this.apiAssociados+'?filtro={"vendedor":"'+vendedor+'"}');
  }

  getAssociadosByVendedorProjection(vendedor:any,array:any){
    return this.http.get(this.apiAssociados+'?filtro={"vendedor":"'+vendedor+'"}&project={'+array+'}');
  }

  getAssociadosVivamax(){
    return this.http.get(this.apiAssociados+'?filtro={"empresa":"VIVA MAX"}');
  }

  getAssociadosPlanoFisicoCarne(){
    return this.http.get(this.apiAssociados+'?filtro={"planoFisicoCheck":true,"$or":[{"formaPagamento":"BOLETO"},{"formaPagamento":"CARNÊ"}]}');
  }

  getAssociadosPendentesCelesc(){
    return this.http.get(this.apiAssociados+'?filtro={"celescStatus":"Aguardando Envio"}');
  }

  getAssociadosConecta(){
    return this.http.get(this.apiAssociados+'?filtro={"empresa":"CONECTA"}&sort={"dataAdesao":-1}');
  }

  getAssociadosConectaAtivo(){
    return this.http.get(this.apiAssociados+'?filtro={"empresa":"CONECTA","situacao":"ATIVO"}&sort={"dataAdesao":-1}');
  }

  getAssociadosAtivosData(dataInicio:any,dataFim:any){
    return this.http.get(this.apiAssociados+'?filtro={"dataAdesao":{"$gte":"'+dataInicio+'","$lte":"'+dataFim+'"},"situacao":"ATIVO"}&sort={"nome":1}');
  }

  getContasPagar(dataInicio:any,dataFim:any){
    return this.http.get(this.apiFinanceiro+'?filtro={"vencimento":{"$gte":"'+dataInicio+'","$lte":"'+dataFim+'"},"status":"Pendente","tipo":"Saida"}&sort={"vencimento":1}');
  }

  getContasPagarProjection(dataInicio:any,dataFim:any,array:any){
    return this.http.get(this.apiFinanceiro+'?filtro={"vencimento":{"$gte":"'+dataInicio+'","$lte":"'+dataFim+'"},"status":"Pendente","tipo":"Saida"}&sort={"vencimento":1}&project={'+array+'}');
  }

  getTodasContasPagar(){
    return this.http.get(this.apiFinanceiro+'?filtro={"status":"Pendente","tipo":"Saida"}&sort={"vencimento":1,"observacao":1}');
  }

  getEntradas(dataInicio:any,dataFim:any){
    return this.http.get(this.apiFinanceiro+'?filtro={"vencimento":{"$gte":"'+dataInicio+'","$lte":"'+dataFim+'"},"tipo":"Entrada"}&sort={"vencimento":1}');
  }

  getCaixaComissao(dataInicio:any,dataFim:any,array:any){
    return this.http.get(this.apiFinanceiro+'?filtro={"vencimento":{"$gte":"'+dataInicio+'","$lte":"'+dataFim+'"},"tipo":"Entrada"}&sort={"dataPagamento":-1}&project={'+array+'}');
  }

  getContasReceber(dataInicio:any,dataFim:any,favorecido:any){
    return this.http.get(this.apiFinanceiro+'?filtro={"vencimento":{"$gte":"'+dataInicio+'","$lte":"'+dataFim+'"},"favorecido":{"$regex":"'+favorecido+'","$options":"i"},"status":"Pendente","tipo":"Entrada"}&sort={"vencimento":1}');
  }

  getContasReceberProjection(dataInicio:any,dataFim:any,array:any){
    return this.http.get(this.apiFinanceiro+'?filtro={"vencimento":{"$gte":"'+dataInicio+'","$lte":"'+dataFim+'"},"status":"Pendente","tipo":"Entrada"}&sort={"vencimento":1}&project={'+array+'}');
  }

  getContasPagas(dataInicio:any,dataFim:any,fornecedor:any){
    return this.http.get(this.apiFinanceiro+'?filtro={"dataPagamento":{"$gte":"'+dataInicio+'","$lte":"'+dataFim+'"},"fornecedor":{"$regex":"'+fornecedor+'","$options":"i"},"status":"Pago"}&sort={"dataPagamento":1}');
  }

  getContasCliente(nome:any, cpf:any){
    return this.http.get(this.apiFinanceiro+'?filtro={"$or":[{"documentoFavorecido":"'+cpf+'"},{"favorecido":"'+nome+'"}]}&sort={"data":1}');
  }

  getCaixa(dataInicio:any,dataFim:any){
    return this.http.get(this.apiFinanceiro+'?filtro={"dataPagamento":{"$gte":"'+dataInicio+'","$lte":"'+dataFim+'"},"status":"Pago"}&sort={"dataPagamento":1}');
  }

  getCaixaDash(dataInicio:any,dataFim:any){
    return this.http.get(this.apiFinanceiro+'?filtro={"dataPagamento":{"$gte":"'+dataInicio+'","$lte":"'+dataFim+'"},"status":"Pago"}&sort={"dataPagamento":1}&project={"dataPagamento":1,"valorTotal":1,"tipo":1}');
  }

  getCredenciadosFilter(laboratorio:any,credenciado:any,especialidade:any,exame:any,cidade:any){
    let lab = laboratorio == true ? '"laboratorioCheck":true,' : '';
    let espec = especialidade != '' ?  '"$or":[{"especialidade":{"$regex":"'+especialidade+'","$options":"i"}},{"profissionais.especialidade":{"$regex":"'+especialidade+'","$options":"i"}}],' : '';
    let exam = exame != '' ? '"exames.nomeExame":{"$regex":"'+exame+'","$options":"i"},' : '';
    return this.http.get(this.apiCredenciados+'?filtro={'+lab+espec+exam+'"municipio":{"$regex":"'+cidade+'","$options":"i"},"fantasiaCredenciado":{"$regex":"'+credenciado+'","$options":"i"}}');
  }

  getFinanceiroCC(dataInicio:any,dataFim:any,centroCusto:any,contaOrcamentaria:any,contaContabil:any,formaPagamento:any,fornecedorConta:any){
    let cCusto = "";
    let cC = "";
    let cO = "";
    let cContabil = "";
    let formaPgto = "";
    let fornecedor = "";
    if(centroCusto != ''){cCusto = '"centrosCusto.centroDeCusto":"'+centroCusto+'",'};
    if(contaOrcamentaria != ''){cO = '"centrosCusto.contaOrcamentaria":"'+contaOrcamentaria+'",'};
    if(contaContabil != ''){cC = '"centrosCusto.contaContabil":"'+contaContabil+'",'};
    if(formaPagamento != ''){formaPgto = '"formaPagamento":"'+formaPagamento+'",'};
    if(fornecedorConta != ''){fornecedor = '"$or":[{"fornecedor":{"$regex":"'+fornecedorConta+'","$options":"i"}},{"favorecido":{"$regex":"'+fornecedorConta+'","$options":"i"}}],'};
    return this.http.get(this.apiFinanceiro+'?filtro={'+cCusto+cC+cO+cContabil+formaPgto+fornecedor+'"dataPagamento":{"$gte":"'+dataInicio+'","$lte":"'+dataFim+'"},"status":"Pago"}&sort={"dataPagamento":1}');
  }
 
  getAssociadosMatricula(key:any,empresa:any){
    let emp:any = empresa != "TODOS" ? '"empresa":"'+empresa+'",' : "";
    return this.http.get(this.apiAssociados+'?filtro={'+emp+'"matricula":'+key+'}&sort={"nome":1}');
  }
  
  getAssociadosCpf(cpf:any,empresa:any){
    let emp:any = empresa != "TODOS" ? '"empresa":"'+empresa+'",' : "";
    return this.http.get(this.apiAssociados+'?filtro={'+emp+'"cpf":"'+cpf+'"}&sort={"nome":1}');
  }

  getAssociadoNome(titular:any,empresa:any){
    let emp:any = empresa != "TODOS" ? '"empresa":"'+empresa+'",' : "";
    return this.http.get(this.apiAssociados+'?filtro={'+emp+'"nome":{"$regex":"'+titular+'","$options":"i"}}&sort={"_id":-1}');
   }

   getTodosAssociadosData(dtInicio:any,dtFim:any,empresa:any){
    let emp:any = empresa != "TODOS" ? '"empresa":"'+empresa+'",' : "";
    return this.http.get(this.apiAssociados+'?filtro={'+emp+'"dataAdesao":{"$gte":"'+dtInicio+'","$lte":"'+dtFim+'"}}&sort={"_id":-1}');
  }

  getTotalCaixa(dataInicio:any,dataFim:any,fornecedor:any,formaPagamento:any,banco:any){
    return this.http.get(this.apiFinanceiro+'?filtro={"formaPagamento":{"$regex":"'+formaPagamento+'","$options":"i"},"banco":{"$regex":"'+banco+'","$options":"i"},"dataPagamento":{"$gte":"'+dataInicio+'","$lte":"'+dataFim+'"},"$or":[{"fornecedor":{"$regex":"'+fornecedor+'","$options":"i"}},{"favorecido":{"$regex":"'+fornecedor+'","$options":"i"}}],"status":"Pago"}&sort={"dataPagamento":1}&project={"_id":1,"valorTotal":1,"tipo":1}');
  }

  getCaixaFornecedor(dataInicio:any,dataFim:any,fornecedor:any,formaPagamento:any,banco:any,skip:number,limit:number){
    return this.http.get(this.apiFinanceiro+'?filtro={"formaPagamento":{"$regex":"'+formaPagamento+'","$options":"i"},"banco":{"$regex":"'+banco+'","$options":"i"},"dataPagamento":{"$gte":"'+dataInicio+'","$lte":"'+dataFim+'"},"$or":[{"fornecedor":{"$regex":"'+fornecedor+'","$options":"i"}},{"favorecido":{"$regex":"'+fornecedor+'","$options":"i"}}],"status":"Pago"}&sort={"dataPagamento":1}&limit=' + limit + '&skip='+skip);
  }

  getAssociadosCanceladosData(dataInicio:any,dataFim:any){
    return this.http.get(this.apiAssociados+'?filtro={"dataCancelamento":{"$gte":"'+dataInicio+'","$lte":"'+dataFim+'"},"situacao":"CANCELADO"}&sort={"nome":1}');
  }

  getAssociadosSolicitacaoCancelados(dataInicio:any,dataFim:any){
    return this.http.get(this.apiAssociados+'?filtro={"dataSolicitacaoCancelamento":{"$gte":"'+dataInicio+'","$lte":"'+dataFim+'"},"solicitouCancelamento":true,"situacao":{"$not":{"$regex":"CANCELADO","$options":"i"}}}&sort={"nome":1}');
  }

  getAssociadosVivamaxMatricula(key:any){
    return this.http.get(this.apiAssociados+'?filtro={"empresa":"VIVA MAX","matricula":'+key+'}&sort={"nome":1}');
  }

  getAssociadosSegurosMatricula(key:any){
    return this.http.get(this.apiAssociados+'?filtro={"empresa":"SEGUROS","matricula":'+key+'}&sort={"nome":1}');
  }

  getAssociadosVivamaxCpf(cpf:any){
    return this.http.get(this.apiAssociados+'?filtro={"empresa":"VIVA MAX","cpf":"'+cpf+'"}&sort={"nome":1}');
  }

  getAssociadosSegurosCpf(cpf:any){
    return this.http.get(this.apiAssociados+'?filtro={"empresa":"SEGUROS","cpf":"'+cpf+'"}&sort={"nome":1}');
  }

  getAssociadosConectaMatricula(key:any){
    return this.http.get(this.apiAssociados+'?filtro={"empresa":"CONECTA","matricula":'+key+'}&sort={"nome":1}');
  }

  getAssociadosConectaCpf(cpf:any){
    return this.http.get(this.apiAssociados+'?filtro={"empresa":"CONECTA","cpf":"'+cpf+'"}&sort={"nome":1}');
  }  

  getSubContratosByNome(nome){
    return this.http.get(this.apiSubContratos+'?filtro={"nome":"'+nome+'"}');
  }

  getUsuariosTipo(tipo:any){
    return this.http.get(this.apiUsuarios+'?filtro={"tipo":"'+tipo+'"}');
  }

  getAssociadosVivamaxTitular(titular:any){
    return this.http.get(this.apiAssociados+'?filtro={"empresa":"VIVA MAX","nome":{"$regex":"'+titular+'","$options":"i"}}&sort={"_id":-1}');
   }
 
   getAssociadosSegurosTitular(titular:any){
     return this.http.get(this.apiAssociados+'?filtro={"empresa":"SEGUROS","nome":{"$regex":"'+titular+'","$options":"i"}}&sort={"_id":-1}');
    }
 
   getAssociadosData(dtInicio:any,dtFim:any){
     return this.http.get(this.apiAssociados+'?filtro={"empresa":"VIVA MAX","dataAdesao":{"$gte":"'+dtInicio+'","$lte":"'+dtFim+'"}}&sort={"_id":-1}');
   }
 
   getAssociadosSegurosData(dtInicio:any,dtFim:any){
     return this.http.get(this.apiAssociados+'?filtro={"empresa":"SEGUROS","dataAdesao":{"$gte":"'+dtInicio+'","$lte":"'+dtFim+'"}}&sort={"_id":-1}');
   }
 
   getAssociadosVivamaxBeneficiario(nomeBeneficiario:any){
     return this.http.get(this.apiAssociados+'?filtro={"dependentes.nome":{"$regex":"'+nomeBeneficiario+'","$options":"i"}}&sort={"_id":-1}');
   }
 
   getAssociadosVivamaxBeneficiarioExtra(nomeBeneficiario:any){
     return this.http.get(this.apiAssociados+'?filtro={"dependentesExtra.nome":{"$regex":"'+nomeBeneficiario+'","$options":"i"}}&sort={"_id":-1}');
   }
 
   getAssociadosConectaTitular(titular:any){
     return this.http.get(this.apiAssociados+'?filtro={"empresa":"CONECTA","nome":{"$regex":"'+titular+'","$options":"i"}}&sort={"_id":-1}');
   }
 
   getAssociadosConectaData(dtInicio:any,dtFim:any){
     return this.http.get(this.apiAssociados+'?filtro={"empresa":"CONECTA","dataAdesao":{"$gte":"'+dtInicio+'","$lte":"'+dtFim+'"}}&sort={"_id":-1}');
   }
 
   getAssociadosConectaBeneficiario(nomeBeneficiario:any){
     return this.http.get(this.apiAssociados+'?filtro={"empresa":"CONECTA","dependentes.nome":{"$regex":"'+nomeBeneficiario+'","$options":"i"}}');
   } 
 
   getAssociadoByPlano(plano:any){
    return this.http.get(this.apiAssociados+'?filtro={"plano":"'+plano+'"}');
  }

  getAssociadoByPlanoAtivos(plano:any){
    return this.http.get(this.apiAssociados+'?filtro={"plano":"'+plano+'","situacao":{"$ne":"CANCELADO"}}');
  }

  getPlanos(){
    return this.http.get(this.apiPlanos+'?filtro={"planoVendas":true}&sort={"empresaOrigem":-1,"tipo":-1,"nome":1}');
  }

  getPlanosConecta(){
    return this.http.get(this.apiPlanos+'?filtro={"planoVendas":true,"empresaOrigem":"CONECTA"}&sort={"tipo":-1,"nome":1}');
  }

  getPlanosVivamax(){
    return this.http.get(this.apiPlanos+'?filtro={"planoVendas":true,"empresaOrigem":"VIVA MAX"}&sort={"tipo":-1,"nome":1}');
  }

  getPlanosVivamaxSeguro(){
    return this.http.get(this.apiPlanos+'?filtro={"planoVendas":true,"planoSeguro":true}&sort={"tipo":-1,"nome":1}');
  }

  getAllPlanosConecta(){
    return this.http.get(this.apiPlanos+'?filtro={"empresaOrigem":"CONECTA"}&sort={"tipo":-1,"nome":1}');
  }

  getAllPlanosVivamax(){
    return this.http.get(this.apiPlanos+'?filtro={"empresaOrigem":"VIVA MAX"}&sort={"tipo":-1,"nome":1}');
  }

  getAllPlanosVivamaxSeguro(){
    return this.http.get(this.apiPlanos+'?filtro={"planoSeguro":true}&sort={"tipo":-1,"nome":1}');
  }

  getAnexosEmpresasById(id:any){
    return this.http.get(this.apiEmpresas+'/'+id+'&project={"anexos":1}');
  }

  getEmpresasByNome(nome:any){
    return this.http.get(this.apiEmpresas+'?filtro={"fantasiaEmpresa":"'+nome+'"}');
  }

  getPlanosVivamaxByTipoByNome(tipo,nome){
    return this.http.get(this.apiPlanos+'?filtro={"empresaOrigem":"VIVA MAX","tipo":"'+tipo+'","nome":"'+nome+'"}');
  }

  getPlanosConectaByTipoByNome(tipo,nome){
    return this.http.get(this.apiPlanos+'?filtro={"empresaOrigem":"CONECTA","tipo":"'+tipo+'","nome":"'+nome+'"}');
  }

  getPlanosEmpresariais(){
    return this.http.get(this.apiPlanos+'?filtro={"tipo":"PLANO EMPRESARIAL"}');
  }

  getFaturamentoByData(data:any){
    return this.http.get(this.apiFaturamento+'?filtro={"data":"'+data+'"}')
  }

  getFaturamentoByDataFaturamento(data:any){
    return this.http.get(this.apiFaturamento+'?filtro={"dataFaturamento":{"$lte":"'+data+'"}}')
  }

  getAssociadosAniversario(data:any){
    return this.http.get(this.apiAssociados+'?filtro={"nascimento":{"$regex":"'+data+'"},"situacao":"ATIVO"}')
  }

  getAssociadosByDataAtivo(dtInicio:any,dtFim:any){
    return this.http.get(this.apiAssociados+'?filtro={"data":{"$gte":"'+dtInicio+'","$lte":"'+dtFim+'"},"situacao":"ATIVO"}');
  }

  getAssociadosByDataAtivoAlterado(dtInicio:any,dtFim:any,vendedor:any){
    return this.http.get(this.apiAssociados+'?filtro={"vendedor":{"$regex":"'+vendedor+'","$options":"i"},"data":{"$gte":"'+dtInicio+'","$lte":"'+dtFim+'"},"$or":[{"situacao":"ATIVO"},{"situacao":"ALTERAÇÃO"}]}');
  }

  getAssociadosByCidade(cidade:any){
    return this.http.get(this.apiAssociados+'?filtro={"cidade":"'+cidade+'","situacao":"ATIVO"}');
  }

  getAssociadosByAdesaoAtivoAlterado(dtInicio:any,dtFim:any,vendedor:any){
    return this.http.get(this.apiAssociados+'?filtro={"vendedor":{"$regex":"'+vendedor+'","$options":"i"},"dataAdesao":{"$gte":"'+dtInicio+'","$lte":"'+dtFim+'"},"$or":[{"situacao":"ATIVO"},{"situacao":"ALTERAÇÃO"}]}');
  }

  getAgendamentosTodos(){
    return this.http.get(this.apiAssociados+'?filtro={"agendamentos.agendadoParaMedico":{"$exists":true,"$ne":[]}}')
  }

  getAgendamentosTodosProjection(array:any){
    return this.http.get(this.apiAssociados+'?filtro={"agendamentos.agendadoParaMedico":{"$exists":true,"$ne":[]}}&project={'+array+'}')
  }

  getAgendamentos(data){
    return this.http.get(this.apiAssociados+'?filtro={"agendamentos.agendadoParaMedico":"'+data+'"}')
  }

  getAgendamentosProjection(data:any,array:any){
    return this.http.get(this.apiAssociados+'?filtro={"agendamentos.agendadoParaMedico":"'+data+'"}&project={'+array+'}')
  }
  
  getMaiorIdade(dataLimite){
    return this.http.get(this.apiAssociados+'?filtro={"$or":[{"dependentes.tipo":"FILHO"},{"dependentes.tipo":"FILHA"}],"dependentes.nascimento":{"$lt":"'+dataLimite+'"}}');
   }

   getMaiorIdadeProjection(dataLimite:any,array:any){
    return this.http.get(this.apiAssociados+'?filtro={"$or":[{"dependentes.tipo":"FILHO"},{"dependentes.tipo":"FILHA"}],"dependentes.nascimento":{"$lt":"'+dataLimite+'"}}&project={'+array+'}');
   }

   getCredenciadosSearch(nome,esp,cidade){
    return this.http.get(this.apiCredenciados+'?filtro={"fantasiaCredenciado":{"$regex":"'+nome+'","$options":"i"},"$or":[{"especialidade":{"$regex":"'+esp+'","$options":"i"}},{"profissionais.especialidade":{"$regex":"'+esp+'","$options":"i"}}],"municipio":{"$regex":"'+cidade+'","$options":"i"}}');
  }

  getEmpresasSearch(nome,cidade){
    return this.http.get(this.apiEmpresas+'?filtro={"fantasiaEmpresa":{"$regex":"'+nome+'","$options":"i"},"municipio":{"$regex":"'+cidade+'","$options":"i"}}');
  }

  getAssociadosByCodigoEmpresa(codigo:any){
    return this.http.get(this.apiAssociados+'?filtro={"codigoEmpresa":"'+codigo+'"}')
  }

  getAssociadosBySubContrato(nome:any){
    return this.http.get(this.apiAssociados+'?filtro={"subContrato":"'+nome+'"}')
  }

  getFinanceiro(empresa:any){
    return this.http.get(this.apiFinanceiro+'?filtro={"favorecido":"'+empresa+'","tipo":"Entrada"}');
  }

  getUsuariosByEmail(email:any){
    return this.http.get(this.apiUsuarios+'?filtro={"email":"'+email+'"}');
  }

  getAssociadoByPlanoMkt(plano:any){
    return this.http.get(this.apiAssociados+'?filtro={"plano":"'+plano+'","$or":[{"situacao":"ATIVO"},{"situacao":"ALTERAÇÃO"}]}&sort={"nome":1}');
  }

  getAssociadoByOrigemEmpresaMkt(empresa:any){
    return this.http.get(this.apiAssociados+'?filtro={"empresa":"'+empresa+'","$or":[{"situacao":"ATIVO"},{"situacao":"ALTERAÇÃO"}]}&sort={"nome":1}');
  }

  getAssociadoByEmpresaMkt(cod:any){
    return this.http.get(this.apiAssociados+'?filtro={"codigoEmpresa":"'+cod+'","$or":[{"situacao":"ATIVO"},{"situacao":"ALTERAÇÃO"}]}&sort={"nome":1}');
  }
  
  getAssociadosByCidadeMkt(cidade:any){
    return this.http.get(this.apiAssociados+'?filtro={"municipio":{"$regex":"'+cidade+'","$options":"i"},"$or":[{"situacao":"ATIVO"},{"situacao":"ALTERAÇÃO"}]}&sort={"nome":1}');
  }

  getAssociadosByAdesaoMkt(dtInicio:any,dtFim:any){
    return this.http.get(this.apiAssociados+'?filtro={"dataAdesao":{"$gte":"'+dtInicio+'","$lte":"'+dtFim+'"},"$or":[{"situacao":"ATIVO"},{"situacao":"ALTERAÇÃO"}]}&sort={"nome":1}');
  }

  getAssociadoBySubContratooMkt(subContrato:any){
    return this.http.get(this.apiAssociados+'?filtro={"subContrato":"'+subContrato+'","$or":[{"situacao":"ATIVO"},{"situacao":"ALTERAÇÃO"}]}&sort={"nome":1}');
  }

  getCanceladoInadimplenteCpf(cpf:any){
    return this.http.get(this.apiAssociados+'?filtro={"cpf":"'+cpf+'","situacao":"CANCELADO","motivoCancelamento":"INADIMPLÊNCIA"}');
  }

  getAllUsuariosCanceladosProjection(array:any){
    return this.http.get(this.apiAssociados+'?filtro={"$or":[{"situacao":"CANCELADO"},{"situacao":"ALTERAÇÃO"}]}&project={'+array+'}');
  }

  getVendasByIdVendedor(idVendedor:any){
    return this.http.get(this.apiVendas+'?filtro={"idVendedor":"'+idVendedor+'"}&sort={"data":-1}');
  }

  getVendas(dtInicio:any,dtFim:any,vendedor:any){
    return this.http.get(this.apiVendas+'?filtro={"data":{"$gte":"'+dtInicio+'","$lte":"'+dtFim+'"},"vendedor":{"$regex":"'+vendedor+'","$options":"i"}}&sort={"data":-1}');
  }
  getVendedores(){
    return this.http.get(this.apiUsuarios+'?filtro={"$or":[{"tipo":"VENDEDOR"},{"tipo":"REPRESENTANTE PJ"}]}&sort={"nome":1}');
  }

  getAllUsuariosEscritorio(){
    return this.http.get(this.apiUsuarios+'?filtro={"situacao":{"$not":{"$regex":"DEMITIDO","$options":"i"}},"tipo":{"$not":{"$regex":"VENDEDOR","$options":"i"}}}&sort={"nome":1}');
  }

  getAllUsuariosEscritorioProjection(array:any){
    return this.http.get(this.apiUsuarios+'?filtro={"situacao":{"$not":{"$regex":"DEMITIDO","$options":"i"}},"tipo":{"$not":{"$regex":"VENDEDOR","$options":"i"}}}&sort={"nome":1}&project={'+array+'}');
  }

  getVendedoresAtivos(){
    return this.http.get(this.apiUsuarios+'?filtro={"colaboradorComercial":true,"situacao":{"$not":{"$regex":"DEMITIDO","$options":"i"}}}&sort={"nome":1}');
  }

  getVendedoresAtivosProjection(array:any){
    return this.http.get(this.apiUsuarios+'?filtro={"colaboradorComercial":true,"situacao":{"$not":{"$regex":"DEMITIDO","$options":"i"}}}&sort={"nome":1}&project={'+array+'}');
  }

  getLogsData(dtI,dtF){
    return this.http.get(this.apiLogs+'?filtro={"data":{"$gte":"'+dtI+'","$lte":"'+dtF+'"}}&sort={"data":1,"hora":-1}');
  }

  getLogsDataMenu(dtI,dtF,menu){
    return this.http.get(this.apiLogs+'?filtro={"data":{"$gte":"'+dtI+'","$lte":"'+dtF+'"},"menu":{"$regex":"'+menu+'","$options":"i"}}&sort={"data":1,"hora":-1}');
  }

  getLogsDataUsuario(dtI,dtF,user){
    return this.http.get(this.apiLogs+'?filtro={"data":{"$gte":"'+dtI+'","$lte":"'+dtF+'"},"usuario":{"$regex":"'+user+'","$options":"i"}}&sort={"data":1,"hora":-1}');
  }

  getLogsDataDescricao(dtI,dtF,desc){
    return this.http.get(this.apiLogs+'?filtro={"data":{"$gte":"'+dtI+'","$lte":"'+dtF+'"},"descricao":{"$regex":"'+desc+'","$options":"i"}}&sort={"data":1,"hora":-1}');
  }

  getAssociadosPendentes(){
    return this.http.get(this.apiAssociados+'?filtro={"situacao":"PENDENTE"}&sort={"nome":1}');
  }
  
  getSubContratosProjection(array:any){
    return this.http.get(this.apiSubContratos+'?project={'+array+'}');
  }
  
  getCredenciadosProjection(array:any){
    return this.http.get(this.apiCredenciados+'?project={'+array+'}')
  }

  getAssociadosProjection(array:any){
    return this.http.get(this.apiAssociados+'?project={'+array+'}&sort={"_id":-1}');
  }

  getAssociadoByCpf(array:any,cpf:any){
    return this.http.get(this.apiAssociados+'?project={'+array+'}&filtro={"cpf":"'+cpf+'"}&sort={"empresa":-1}');
  }

  getAssociadoByCpfEmpresa(array:any,cpf:any,empresa:any){
    return this.http.get(this.apiAssociados+'?project={'+array+'}&filtro={"cpf":"'+cpf+'","empresa":"'+empresa+'"}&sort={"empresa":-1}');
  }
    
  getTotalAssociadosByPlanos(valorPersonalizado:any,empresaPlano:any,tipoPlano:any,exceto:any,dataInicioPlano:any,dataFimPlano:any,cidadePlano:any,plano:any,excetoPlano:any,vendors:any,situacaoPlanos:any,sexo:any, taxaAdesao:any, subContrato:any, profissao:any,nascimento:any,motivoPendencia:any,motivoInadimplencia:any,mesPagamento:any,formaPagamento:any,codigoEmpresa:any){
    let nomePlano;
    let buscaPlano;
    let sitPlano;
    let relVendedores;
    let buscaSituacao;
    let buscaVendedores;
    let motivoInad = "";; 
    let motivoPen = "";;
    let mesPgto = "";;
    let codEmpresa = "";
    let sub = "";;
    let excecao = "";
    let adesao = "";
    let planoTipo = "";
    let planPers = valorPersonalizado == "TODOS" ? '' : '"valorPersonalizado":'+valorPersonalizado+',';
    if(codigoEmpresa != ''){codEmpresa = '"codigoEmpresa":"'+codigoEmpresa+'",';};
    if(mesPagamento != ''){mesPgto = '"mesFolhaPagamento":{"$regex":"'+mesPagamento+'","$options":"i"},';}
    if(motivoInadimplencia != ''){motivoInad = '"motivoInadimplencia":{"$regex":"'+motivoInadimplencia+'","$options":"i"},';}
    if(motivoPendencia != ''){motivoPen = '"motivoPendencia":{"$regex":"'+motivoPendencia+'","$options":"i"},';}
    if(subContrato != ''){sub = '"subContrato":"'+subContrato+'",';}
    if(plano && plano.length > 0){
      nomePlano = JSON.stringify(plano);      
      buscaPlano = '"plano":{"$in":'+nomePlano+'},';
    }else{
      buscaPlano = '"plano":{"$regex":"'+plano+'"},';
    }
    if(situacaoPlanos && situacaoPlanos.length > 0 && situacaoPlanos != "TODOS"){
      sitPlano = JSON.stringify(situacaoPlanos);
      buscaSituacao = '"situacao":{"$in":'+sitPlano+'},';
    }else{
      buscaSituacao = '"situacao":{"$regex":"'+situacaoPlanos+'"},';
    }
    if(vendors && vendors.length > 0 && vendors != "TODOS"){
      relVendedores = JSON.stringify(vendors);
      buscaVendedores = '"vendedor":{"$in":'+relVendedores+'},';
    }else{
      buscaVendedores = '"vendedor":{"$regex":"'+vendors+'"},';
    }
    if(exceto == "SIM"){excecao = '"plano":{"$not":{"$regex":"'+excetoPlano+'","$options":"i"}},';}
    if(taxaAdesao != null){adesao = '"taxaAdesao":'+taxaAdesao+',';}
    if(tipoPlano == "PLANO FISICO"){
      planoTipo = '"planoFisicoCheck":true,';
    }
    if(tipoPlano == "PLANO EMPRESARIAL"){
      planoTipo = '"planoEmpresarialCheck":true,';
    }
    if(tipoPlano == "PLANO SERVIDOR"){
      planoTipo = '"subContrato":{"$exists":true},"$and":[{"codigoEmpresa":null},{"codigoEmpresa":{"$exists":false}}],"$and":[{"$or":[{"planoEmpresarialCheck":false},{"planoEmpresarialCheck":null}]},{"$or":[{"planoFisicoCheck":false},{"planoFisicoCheck":null}]}],';
    }
    if(tipoPlano == "TODOS" || tipoPlano == null){
      planoTipo = "";
    }
    return this.http.get(this.apiAssociados+'?filtro={'+planPers+buscaPlano+excecao+motivoInad+motivoPen+mesPgto+codEmpresa+excecao+adesao+planoTipo+sub+buscaSituacao+buscaVendedores+'"empresa":{"$regex":"'+empresaPlano+'","$options":"i"},"nascimento":{"$regex":"'+nascimento+'","$options":"i"},"dataAdesao":{"$gte":"'+dataInicioPlano+'","$lte":"'+dataFimPlano+'"},"municipio":{"$regex":"'+cidadePlano+'","$options":"i"},"sexo":{"$regex":"'+sexo+'","$options":"i"},"funcao":{"$regex":"'+profissao+'","$options":"i"},"formaPagamento":{"$regex":"'+formaPagamento+'","$options":"i"}}&project={"_id":1}');
  }

  getAssociadosByPlanos(valorPersonalizado:any,empresaPlano:any,tipoPlano:any,exceto:any,dataInicioPlano:any,dataFimPlano:any,cidadePlano:any,plano:any,excetoPlano:any,vendors:any,situacaoPlanos:any,sexo:any, taxaAdesao:any, subContrato:any, profissao:any,nascimento:any,motivoPendencia:any,motivoInadimplencia:any,mesPagamento:any,formaPagamento:any,codigoEmpresa:any,skip:number,limit:number){
    let nomePlano;
    let buscaPlano;
    let sitPlano;
    let relVendedores;
    let buscaSituacao;
    let buscaVendedores;
    let motivoInad = "";; 
    let motivoPen = "";;
    let mesPgto = "";;
    let codEmpresa = "";
    let sub = "";;
    let excecao = "";
    let adesao = "";
    let planoTipo = "";
    let planPers = valorPersonalizado == "TODOS" ? '' : '"valorPersonalizado":'+valorPersonalizado+',';
    if(codigoEmpresa != ''){codEmpresa = '"codigoEmpresa":"'+codigoEmpresa+'",';};
    if(mesPagamento != ''){mesPgto = '"mesFolhaPagamento":{"$regex":"'+mesPagamento+'","$options":"i"},';}
    if(motivoInadimplencia != ''){motivoInad = '"motivoInadimplencia":{"$regex":"'+motivoInadimplencia+'","$options":"i"},';}
    if(motivoPendencia != ''){motivoPen = '"motivoPendencia":{"$regex":"'+motivoPendencia+'","$options":"i"},';}
    if(subContrato != ''){sub = '"subContrato":"'+subContrato+'",';}
    if(plano && plano.length > 0){
      nomePlano = JSON.stringify(plano);      
      buscaPlano = '"plano":{"$in":'+nomePlano+'},';
    }else{
      buscaPlano = '"plano":{"$regex":"'+plano+'"},';
    }
    if(situacaoPlanos && situacaoPlanos.length > 0 && situacaoPlanos != "TODOS"){
      sitPlano = JSON.stringify(situacaoPlanos);
      buscaSituacao = '"situacao":{"$in":'+sitPlano+'},';
    }else{
      buscaSituacao = '"situacao":{"$regex":"'+situacaoPlanos+'"},';
    }
    if(vendors && vendors.length > 0 && vendors != "TODOS"){
      relVendedores = JSON.stringify(vendors);
      buscaVendedores = '"vendedor":{"$in":'+relVendedores+'},';
    }else{
      buscaVendedores = '"vendedor":{"$regex":"'+vendors+'"},';
    }
    if(exceto == "SIM"){excecao = '"plano":{"$not":{"$regex":"'+excetoPlano+'","$options":"i"}},';}
    if(taxaAdesao != null){adesao = '"taxaAdesao":'+taxaAdesao+',';}
    if(tipoPlano == "PLANO FISICO"){
      planoTipo = '"planoFisicoCheck":true,';
    }
    if(tipoPlano == "PLANO EMPRESARIAL"){
      planoTipo = '"planoEmpresarialCheck":true,';
    }
    if(tipoPlano == "PLANO SERVIDOR"){
      planoTipo = '"subContrato":{"$exists":true},"$and":[{"codigoEmpresa":null},{"codigoEmpresa":{"$exists":false}}],"$and":[{"$or":[{"planoEmpresarialCheck":false},{"planoEmpresarialCheck":null}]},{"$or":[{"planoFisicoCheck":false},{"planoFisicoCheck":null}]}],';
    }
    if(tipoPlano == "TODOS" || tipoPlano == null){
      planoTipo = "";
    }
    return this.http.get(this.apiAssociados+'?filtro={'+planPers+buscaPlano+excecao+motivoInad+motivoPen+mesPgto+codEmpresa+excecao+adesao+planoTipo+sub+buscaSituacao+buscaVendedores+'"empresa":{"$regex":"'+empresaPlano+'","$options":"i"},"nascimento":{"$regex":"'+nascimento+'","$options":"i"},"dataAdesao":{"$gte":"'+dataInicioPlano+'","$lte":"'+dataFimPlano+'"},"municipio":{"$regex":"'+cidadePlano+'","$options":"i"},"sexo":{"$regex":"'+sexo+'","$options":"i"},"funcao":{"$regex":"'+profissao+'","$options":"i"},"formaPagamento":{"$regex":"'+formaPagamento+'","$options":"i"}}&sort={"nome":1}&limit=' + limit + '&skip=' + skip);
  }

  /* AQUI */
  
  getAssociadosByPlanosGo(valorPersonalizado:any,empresaPlano:any,tipoPlano:any,exceto:any,dataInicioPlano:any,dataFimPlano:any,cidadePlano:any,plano:any,excetoPlano:any,vendors:any,situacaoPlanos:any,sexo:any, taxaAdesao:any, subContrato:any, profissao:any,nascimento:any,motivoPendencia:any,motivoInadimplencia:any,mesPagamento:any,formaPagamento:any,codigoEmpresa:any){
    let nomePlano;
    let buscaPlano;
    let sitPlano;
    let relVendedores;
    let buscaSituacao;
    let buscaVendedores;
    let motivoInad = "";; 
    let motivoPen = "";;
    let mesPgto = "";;
    let codEmpresa = "";
    let sub = "";;
    let excecao = "";
    let adesao = "";
    let planoTipo = "";
    let planPers = valorPersonalizado == "TODOS" ? '' : '"valorPersonalizado":'+valorPersonalizado+',';
    if(codigoEmpresa != ''){codEmpresa = '"codigoEmpresa":"'+codigoEmpresa+'",';};
    if(mesPagamento != ''){mesPgto = '"mesFolhaPagamento":{"$regex":"'+mesPagamento+'","$options":"i"},';}
    if(motivoInadimplencia != ''){motivoInad = '"motivoInadimplencia":{"$regex":"'+motivoInadimplencia+'","$options":"i"},';}
    if(motivoPendencia != ''){motivoPen = '"motivoPendencia":{"$regex":"'+motivoPendencia+'","$options":"i"},';}
    if(subContrato != ''){sub = '"subContrato":"'+subContrato+'",';}
    if(plano && plano.length > 0){
      nomePlano = JSON.stringify(plano);      
      buscaPlano = '"plano":{"$in":'+nomePlano+'},';
    }else{
      buscaPlano = '"plano":{"$regex":"'+plano+'"},';
    }
    if(situacaoPlanos && situacaoPlanos.length > 0 && situacaoPlanos != "TODOS"){
      sitPlano = JSON.stringify(situacaoPlanos);
      buscaSituacao = '"situacao":{"$in":'+sitPlano+'},';
    }else{
      buscaSituacao = '"situacao":{"$regex":"'+situacaoPlanos+'"},';
    }
    if(vendors && vendors.length > 0 && vendors != "TODOS"){
      relVendedores = JSON.stringify(vendors);
      buscaVendedores = '"vendedor":{"$in":'+relVendedores+'},';
    }else{
      buscaVendedores = '"vendedor":{"$regex":"'+vendors+'"},';
    }
    if(exceto == "SIM"){excecao = '"plano":{"$not":{"$regex":"'+excetoPlano+'","$options":"i"}},';}
    if(taxaAdesao != null){adesao = '"taxaAdesao":'+taxaAdesao+',';}
    if(tipoPlano == "PLANO FISICO"){
      planoTipo = '"planoFisicoCheck":true,';
    }
    if(tipoPlano == "PLANO EMPRESARIAL"){
      planoTipo = '"planoEmpresarialCheck":true,';
    }
    if(tipoPlano == "PLANO SERVIDOR"){
      planoTipo = '"subContrato":{"$exists":true},"$and":[{"codigoEmpresa":null},{"codigoEmpresa":{"$exists":false}}],"$and":[{"$or":[{"planoEmpresarialCheck":false},{"planoEmpresarialCheck":null}]},{"$or":[{"planoFisicoCheck":false},{"planoFisicoCheck":null}]}],';
    }
    if(tipoPlano == "TODOS" || tipoPlano == null){
      planoTipo = "";
    }
    return this.http.get(this.apiAssociados+'?filtro={'+planPers+buscaPlano+excecao+motivoInad+motivoPen+mesPgto+codEmpresa+excecao+adesao+planoTipo+sub+buscaSituacao+buscaVendedores+'"empresa":{"$regex":"'+empresaPlano+'","$options":"i"},"nascimento":{"$regex":"'+nascimento+'","$options":"i"},"dataAdesao":{"$gte":"'+dataInicioPlano+'","$lte":"'+dataFimPlano+'"},"municipio":{"$regex":"'+cidadePlano+'","$options":"i"},"sexo":{"$regex":"'+sexo+'","$options":"i"},"funcao":{"$regex":"'+profissao+'","$options":"i"},"formaPagamento":{"$regex":"'+formaPagamento+'","$options":"i"}}&sort={"nome":1}');
  }

  getTotalAssociadosByAgendamento(dtInicio:any,dtFim:any,matricula:any,valor:any,medico:any,cidade:any,pagamento:any,paciente:any){
    if(matricula != null && valor == null){
      return this.http.get(this.apiAssociados+'?filtro={"agendamentos.dataAgendamento":{"$gte":"'+dtInicio+'","$lte":"'+dtFim+'"},"agendamentos.pacienteMedico":{"$regex":"'+paciente+'","$options":"i"},"agendamentos.laboratorioMedico":{"$regex":"'+medico+'","$options":"i"},"agendamentos.formaPagamento":{"$regex":"'+pagamento+'","$options":"i"},"municipio":{"$regex":"'+cidade+'","$options":"i"},"matricula":'+matricula+'}&project={"_id":1}');
    }
    if(valor != null && matricula == null){
      return this.http.get(this.apiAssociados+'?filtro={"agendamentos.dataAgendamento":{"$gte":"'+dtInicio+'","$lte":"'+dtFim+'"},"agendamentos.pacienteMedico":{"$regex":"'+paciente+'","$options":"i"},"agendamentos.laboratorioMedico":{"$regex":"'+medico+'","$options":"i"},"agendamentos.formaPagamento":{"$regex":"'+pagamento+'","$options":"i"},"municipio":{"$regex":"'+cidade+'","$options":"i"},"agendamentos.valorConsulta":'+valor+'}&project={"_id":1}');
    }
    if(matricula != null && valor != null){
      return this.http.get(this.apiAssociados+'?filtro={"agendamentos.dataAgendamento":{"$gte":"'+dtInicio+'","$lte":"'+dtFim+'"},"agendamentos.pacienteMedico":{"$regex":"'+paciente+'","$options":"i"},"agendamentos.laboratorioMedico":{"$regex":"'+medico+'","$options":"i"},"agendamentos.formaPagamento":{"$regex":"'+pagamento+'","$options":"i"},"municipio":{"$regex":"'+cidade+'","$options":"i"},"agendamentos.valorConsulta":'+valor+',"matricula":'+matricula+'}&project={"_id":1}');
    }
    if(matricula == null && valor == null){
      return this.http.get(this.apiAssociados+'?filtro={"agendamentos.dataAgendamento":{"$gte":"'+dtInicio+'","$lte":"'+dtFim+'"},"agendamentos.pacienteMedico":{"$regex":"'+paciente+'","$options":"i"},"agendamentos.laboratorioMedico":{"$regex":"'+medico+'","$options":"i"},"agendamentos.formaPagamento":{"$regex":"'+pagamento+'","$options":"i"},"municipio":{"$regex":"'+cidade+'","$options":"i"}}&project={"_id":1}');
    } 
  }

  getAssociadosByAgendamento(dtInicio:any,dtFim:any,matricula:any,valor:any,medico:any,cidade:any,pagamento:any,paciente:any,skip:number,limit:number){
    if(matricula != null && valor == null){
      return this.http.get(this.apiAssociados+'?filtro={"agendamentos.dataAgendamento":{"$gte":"'+dtInicio+'","$lte":"'+dtFim+'"},"agendamentos.pacienteMedico":{"$regex":"'+paciente+'","$options":"i"},"agendamentos.laboratorioMedico":{"$regex":"'+medico+'","$options":"i"},"agendamentos.formaPagamento":{"$regex":"'+pagamento+'","$options":"i"},"municipio":{"$regex":"'+cidade+'","$options":"i"},"matricula":'+matricula+'}&project={"agendamentos":1}&limit=' + limit + '&skip=' + skip);
    }
    if(valor != null && matricula == null){
      return this.http.get(this.apiAssociados+'?filtro={"agendamentos.dataAgendamento":{"$gte":"'+dtInicio+'","$lte":"'+dtFim+'"},"agendamentos.pacienteMedico":{"$regex":"'+paciente+'","$options":"i"},"agendamentos.laboratorioMedico":{"$regex":"'+medico+'","$options":"i"},"agendamentos.formaPagamento":{"$regex":"'+pagamento+'","$options":"i"},"municipio":{"$regex":"'+cidade+'","$options":"i"},"agendamentos.valorConsulta":'+valor+'}&project={"agendamentos":1}&limit=' + limit + '&skip=' + skip);
    }
    if(matricula != null && valor != null){
      return this.http.get(this.apiAssociados+'?filtro={"agendamentos.dataAgendamento":{"$gte":"'+dtInicio+'","$lte":"'+dtFim+'"},"agendamentos.pacienteMedico":{"$regex":"'+paciente+'","$options":"i"},"agendamentos.laboratorioMedico":{"$regex":"'+medico+'","$options":"i"},"agendamentos.formaPagamento":{"$regex":"'+pagamento+'","$options":"i"},"municipio":{"$regex":"'+cidade+'","$options":"i"},"agendamentos.valorConsulta":'+valor+',"matricula":'+matricula+'}&project={"agendamentos":1}&limit=' + limit + '&skip=' + skip);
    }
    if(matricula == null && valor == null){
      return this.http.get(this.apiAssociados+'?filtro={"agendamentos.dataAgendamento":{"$gte":"'+dtInicio+'","$lte":"'+dtFim+'"},"agendamentos.pacienteMedico":{"$regex":"'+paciente+'","$options":"i"},"agendamentos.laboratorioMedico":{"$regex":"'+medico+'","$options":"i"},"agendamentos.formaPagamento":{"$regex":"'+pagamento+'","$options":"i"},"municipio":{"$regex":"'+cidade+'","$options":"i"}}&project={"agendamentos":1}&limit=' + limit + '&skip=' + skip);
    } 
  }

  getAssociadosByProcedimento(dtInicio:any,dtFim:any,matricula:any,valor:any,medico:any,cidade:any,pagamento:any,paciente:any){
    if(matricula != null && valor == null){
      return this.http.get(this.apiAssociados+'?filtro={"agendamentos.agendadoParaMedico":{"$gte":"'+dtInicio+'","$lte":"'+dtFim+'"},"agendamentos.pacienteMedico":{"$regex":"'+paciente+'","$options":"i"},"agendamentos.laboratorioMedico":{"$regex":"'+medico+'","$options":"i"},"agendamentos.formaPagamento":{"$regex":"'+pagamento+'","$options":"i"},"municipio":{"$regex":"'+cidade+'","$options":"i"},"matricula":'+matricula+'}');
    }
    if(valor != null && matricula == null){
      return this.http.get(this.apiAssociados+'?filtro={"agendamentos.agendadoParaMedico":{"$gte":"'+dtInicio+'","$lte":"'+dtFim+'"},"agendamentos.pacienteMedico":{"$regex":"'+paciente+'","$options":"i"},"agendamentos.laboratorioMedico":{"$regex":"'+medico+'","$options":"i"},"agendamentos.formaPagamento":{"$regex":"'+pagamento+'","$options":"i"},"municipio":{"$regex":"'+cidade+'","$options":"i"},"agendamentos.valorConsulta":'+valor+'}');
    }
    if(matricula != null && valor != null){
      return this.http.get(this.apiAssociados+'?filtro={"agendamentos.agendadoParaMedico":{"$gte":"'+dtInicio+'","$lte":"'+dtFim+'"},"agendamentos.pacienteMedico":{"$regex":"'+paciente+'","$options":"i"},"agendamentos.laboratorioMedico":{"$regex":"'+medico+'","$options":"i"},"agendamentos.formaPagamento":{"$regex":"'+pagamento+'","$options":"i"},"municipio":{"$regex":"'+cidade+'","$options":"i"},"agendamentos.valorConsulta":'+valor+',"matricula":'+matricula+'}');
    }
    if(matricula == null && valor == null){
      return this.http.get(this.apiAssociados+'?filtro={"agendamentos.agendadoParaMedico":{"$gte":"'+dtInicio+'","$lte":"'+dtFim+'"},"agendamentos.pacienteMedico":{"$regex":"'+paciente+'","$options":"i"},"agendamentos.laboratorioMedico":{"$regex":"'+medico+'","$options":"i"},"agendamentos.formaPagamento":{"$regex":"'+pagamento+'","$options":"i"},"municipio":{"$regex":"'+cidade+'","$options":"i"}}');
    } 
  }

  getAssociadosBySinistroTitular(dtInicio:any,dtFim:any,matricula:any,sinistrado:any,situacao:any){
    if(matricula){
      return this.http.get(this.apiAssociados+'?filtro={"sinistro.dataSinistro":{"$gte":"'+dtInicio+'","$lte":"'+dtFim+'"},"nome":{"$regex":"'+sinistrado+'","$options":"i"},"sinistro.situacao":{"$regex":"'+situacao+'","$options":"i"},"matricula":'+matricula+'}');
    }else{
      return this.http.get(this.apiAssociados+'?filtro={"sinistro.dataSinistro":{"$gte":"'+dtInicio+'","$lte":"'+dtFim+'"},"nome":{"$regex":"'+sinistrado+'","$options":"i"},"sinistro.situacao":{"$regex":"'+situacao+'","$options":"i"}}');
    }
  }

  getAssociadosBySinistroDependente(dtInicio:any,dtFim:any,matricula:any,sinistrado:any,situacao:any,tipo:any){
    if(matricula){
      return this.http.get(this.apiAssociados+'?filtro={"dependentes.sinistro.dataSinistro":{"$gte":"'+dtInicio+'","$lte":"'+dtFim+'"},"dependentes.nome":{"$regex":"'+sinistrado+'","$options":"i"},"dependentes.sinistro.situacao":{"$regex":"'+situacao+'","$options":"i"},"dependentes.tipo":{"$regex":"'+tipo+'","$options":"i"},"matricula":'+matricula+'}');
    }else{
      return this.http.get(this.apiAssociados+'?filtro={"dependentes.sinistro.dataSinistro":{"$gte":"'+dtInicio+'","$lte":"'+dtFim+'"},"dependentes.nome":{"$regex":"'+sinistrado+'","$options":"i"},"dependentes.sinistro.situacao":{"$regex":"'+situacao+'","$options":"i"},"dependentes.tipo":{"$regex":"'+tipo+'","$options":"i"}}');
    }
  }

  getAssociadosBySinistroDependenteExtra(dtInicio:any,dtFim:any,matricula:any,sinistrado:any,situacao:any,tipo:any){
     if(matricula){
      return this.http.get(this.apiAssociados+'?filtro={"dependentesExtra.sinistro.dataSinistro":{"$gte":"'+dtInicio+'","$lte":"'+dtFim+'"},"dependentesExtra.nome":{"$regex":"'+sinistrado+'","$options":"i"},"dependentesExtra.sinistro.situacao":{"$regex":"'+situacao+'","$options":"i"},"dependentesExtra.tipo":{"$regex":"'+tipo+'","$options":"i"},"matricula":'+matricula+'}');
    }else{
      return this.http.get(this.apiAssociados+'?filtro={"dependentesExtra.sinistro.dataSinistro":{"$gte":"'+dtInicio+'","$lte":"'+dtFim+'"},"dependentesExtra.nome":{"$regex":"'+sinistrado+'","$options":"i"},"dependentesExtra.sinistro.situacao":{"$regex":"'+situacao+'","$options":"i"},"dependentesExtra.tipo":{"$regex":"'+tipo+'","$options":"i"}}');
    }  
  }

  getTotalAssociadosByDataPlano(dtInicio:any,dtFim:any,plano:any,tipoPlano:any){
    let tipos:any = "";
    if(tipoPlano == "PLANO FISICO"){
      tipos = '"planoFisicoCheck":true,"$or":[{"planoEmpresarialCheck":false},{"planoEmpresarialCheck":null}],';
    }
    if(tipoPlano == "PLANO SERVIDOR"){
      tipos = '"$or":[{"planoFisicoCheck":false},{"planoFisicoCheck":null}],"$or":[{"planoEmpresarialCheck":false},{"planoEmpresarialCheck":null}],';
    }
    if(tipoPlano == "PLANO EMPRESARIAL"){
      tipos = '"$or":[{"planoEmpresarialCheck":false},{"planoEmpresarialCheck":null}],"planoEmpresarialCheck":true,';
    }
    if(tipoPlano == ""){
      tipos = "";
    }
    if(plano && plano.length > 0){
      let planos = JSON.stringify(plano);      
      return this.http.get(this.apiAssociados+'?filtro={'+tipos+'"dataAdesao":{"$gte":"'+dtInicio+'","$lte":"'+dtFim+'"},"plano":{"$in":'+planos+'},"$or":[{"situacao":{"$not":{"$regex":"CANCELADO","$options":"i"}}},{"situacao":"PENDENTE","motivoPendencia":"MIGRAÇÃO VIVA MAX NOVOS PRODUTOS"},{"situacao":"PENDENTE","motivoPendencia":"OUTROS"},{"situacao":"PENDENTE","motivoPendencia":"EXONERACAO/APOSENTADORIA"}]}&project={"_id":1}');
    }else{
      return this.http.get(this.apiAssociados+'?filtro={'+tipos+'"dataAdesao":{"$gte":"'+dtInicio+'","$lte":"'+dtFim+'"},"$or":[{"situacao":{"$not":{"$regex":"CANCELADO","$options":"i"}}},{"situacao":"PENDENTE","motivoPendencia":"MIGRAÇÃO VIVA MAX NOVOS PRODUTOS"},{"situacao":"PENDENTE","motivoPendencia":"OUTROS"},{"situacao":"PENDENTE","motivoPendencia":"EXONERACAO/APOSENTADORIA"}]}&project={"_id":1}');
    }
  }

  getAssociadosByDataPlano(dtInicio:any,dtFim:any,plano:any,tipoPlano:any,skip:any,limit:any){
    let tipos:any = "";
    if(tipoPlano == "PLANO FISICO"){
      tipos = '"planoFisicoCheck":true,"$or":[{"planoEmpresarialCheck":false},{"planoEmpresarialCheck":null}],';
    }
    if(tipoPlano == "PLANO SERVIDOR"){
      tipos = '"$or":[{"planoFisicoCheck":false},{"planoFisicoCheck":null}],"$or":[{"planoEmpresarialCheck":false},{"planoEmpresarialCheck":null}],';
    }
    if(tipoPlano == "PLANO EMPRESARIAL"){
      tipos = '"$or":[{"planoEmpresarialCheck":false},{"planoEmpresarialCheck":null}],"planoEmpresarialCheck":true,';
    }
    if(tipoPlano == ""){
      tipos = "";
    }
    if(plano && plano.length > 0){
      let planos = JSON.stringify(plano);      
      return this.http.get(this.apiAssociados+'?filtro={'+tipos+'"dataAdesao":{"$gte":"'+dtInicio+'","$lte":"'+dtFim+'"},"plano":{"$in":'+planos+'},"$or":[{"situacao":{"$not":{"$regex":"CANCELADO","$options":"i"}}},{"situacao":"PENDENTE","motivoPendencia":"MIGRAÇÃO VIVA MAX NOVOS PRODUTOS"},{"situacao":"PENDENTE","motivoPendencia":"OUTROS"},{"situacao":"PENDENTE","motivoPendencia":"EXONERACAO/APOSENTADORIA"}]}&project={"nome":1,"nascimento":1,"numSorte":1,"motivoPendencia":1,"cpf":1,"empresa":1,"valorCapitalSegurado":1,"dependentes":1,"dependentesExtra":1,"matricula":1,"sexo":1,"plano":1,"dataAdesao":1}&limit=' + limit + '&skip=' + skip);
    }else{
      return this.http.get(this.apiAssociados+'?filtro={'+tipos+'"dataAdesao":{"$gte":"'+dtInicio+'","$lte":"'+dtFim+'"},"$or":[{"situacao":{"$not":{"$regex":"CANCELADO","$options":"i"}}},{"situacao":"PENDENTE","motivoPendencia":"MIGRAÇÃO VIVA MAX NOVOS PRODUTOS"},{"situacao":"PENDENTE","motivoPendencia":"OUTROS"},{"situacao":"PENDENTE","motivoPendencia":"EXONERACAO/APOSENTADORIA"}]}&project={"nome":1,"nascimento":1,"numSorte":1,"motivoPendencia":1,"cpf":1,"empresa":1,"valorCapitalSegurado":1,"dependentes":1,"dependentesExtra":1,"matricula":1,"sexo":1,"plano":1,"dataAdesao":1}&limit=' + limit + '&skip=' + skip);
    }
  }

  getTotalAssociadosCancelados(dataInicio:any,dataFim:any,matricula:any,motivo:any,subContrato:any,cidade:any,vendedor:any){
    let mat = "";
    if(matricula != null){
      mat = '"matricula":'+matricula+'';
    }
    return this.http.get(this.apiAssociados+'?filtro={"situacao":"CANCELADO","dataCancelamento":{"$gte":"'+dataInicio+'","$lte":"'+dataFim+'"},"motivoCancelamento":{"$regex":"'+motivo+'","$options":"i"},"subContrato":{"$regex":"'+subContrato+'","$options":"i"},"municipio":{"$regex":"'+cidade+'","$options":"i"},"vendedor":{"$regex":"'+vendedor+'","$options":"i"}'+mat+'}&project={"_id":1}')
  }

  getAssociadosCancelados(dataInicio:any,dataFim:any,matricula:any,motivo:any,subContrato:any,cidade:any,vendedor:any,skip:any,limit:any){
    let mat = "";
    if(matricula != null){
      mat = '"matricula":'+matricula+'';
    }
    return this.http.get(this.apiAssociados+'?filtro={"situacao":"CANCELADO","dataCancelamento":{"$gte":"'+dataInicio+'","$lte":"'+dataFim+'"},"motivoCancelamento":{"$regex":"'+motivo+'","$options":"i"},"subContrato":{"$regex":"'+subContrato+'","$options":"i"},"municipio":{"$regex":"'+cidade+'","$options":"i"},"vendedor":{"$regex":"'+vendedor+'","$options":"i"}'+mat+'}&project={"dataAdesao":1,"dataCancelamento":1,"matricula":1,"nome":1,"motivoCancelamento":1,"subContrato":1,"totalMensalidade":1,"vendedor":1}&limit=' + limit + '&skip=' + skip)
  }

  getTotalAtendimentos(dataInicio,dataFim,motivo,empresa,plano,subcontrato){
    let mots = "";
    if(motivo && motivo.length > 0){
      if(motivo[0] != ""){
        let motivos = JSON.stringify(motivo);  
        mots = '"historicos.motivo":{"$in":'+motivos+'},';
      }
    }    
    return this.http.get(this.apiAssociados+'?filtro={'+mots+'"localTrabalho":{"$regex":"'+empresa+'","$options":"i"},"plano":{"$regex":"'+plano+'","$options":"i"},"subContrato":{"$regex":"'+subcontrato+'","$options":"i"},"historicos.data":{"$gte":"'+dataInicio+'","$lte":"'+dataFim+'"}}&project={"_id":1}');
  }

  getAtendimentos(dataInicio,dataFim,motivo,empresa,plano,subcontrato,skip,limit){
    let mots = "";
    if(motivo && motivo.length > 0){
      if(motivo[0] != ""){
        let motivos = JSON.stringify(motivo);  
        mots = '"historicos.motivo":{"$in":'+motivos+'},';
      }
    }    
    return this.http.get(this.apiAssociados+'?filtro={'+mots+'"localTrabalho":{"$regex":"'+empresa+'","$options":"i"},"plano":{"$regex":"'+plano+'","$options":"i"},"subContrato":{"$regex":"'+subcontrato+'","$options":"i"},"historicos.data":{"$gte":"'+dataInicio+'","$lte":"'+dataFim+'"}}&project={"historicos":1,"matricula":1,"nome":1,"localTrabalho":1,"plano":1,"subContrato":1}&limit=' + limit + '&skip=' + skip);
  }

  getTotalCombinados(dtI:any,dtF:any,titular:any,tipo:any,subContrato:any,empresa:any,situacaoPlanosComb:any){
    let tipos = "";
    let sitPlano = "";
    let buscaSituacao = "";
    let subs = subContrato ? '"subContrato":"'+subContrato+'",' : '';
    let emps = empresa ? '"codigoEmpresa":"'+empresa+'",' : '';
    if(tipo == "FISICO"){
      tipos = '"planoFisicoCheck":true,"$or":[{"planoEmpresarialCheck":false},{"planoEmpresarialCheck":null}],'
    }
    if(tipo == "SERVIDOR"){
      tipos = '"$or":[{"planoFisicoCheck":false},{"planoFisicoCheck":null}],"$or":[{"planoEmpresarialCheck":false},{"planoEmpresarialCheck":null}],'
    }
    if(tipo == "EMPRESARIAL"){
      tipos = '"$or":[{"planoEmpresarialCheck":false},{"planoEmpresarialCheck":null}],"planoEmpresarialCheck":true,'
    }
    if(tipo == ""){
      tipos = ""
    }
    if(situacaoPlanosComb && situacaoPlanosComb.length > 0 && situacaoPlanosComb != "TODOS"){
      sitPlano = JSON.stringify(situacaoPlanosComb);
      buscaSituacao = '"situacao":{"$in":'+sitPlano+'},'
    }
    return this.http.get(this.apiAssociados+'?filtro={'+tipos+buscaSituacao+subs+emps+'"dataAdesao":{"$gte":"'+dtI+'","$lte":"'+dtF+'"},"nome":{"$regex":"'+titular+'","$options":"i"}}&project={"_id":1}')
  }

  getCombinados(dtI:any,dtF:any,titular:any,tipo:any,subContrato:any,empresa:any,situacaoPlanosComb:any,skip:any,limit:any){
    let tipos = "";
    let sitPlano = "";
    let buscaSituacao = "";
    let subs = subContrato ? '"subContrato":"'+subContrato+'",' : '';
    let emps = empresa ? '"codigoEmpresa":"'+empresa+'",' : '';
    if(tipo == "FISICO"){
      tipos = '"planoFisicoCheck":true,"$or":[{"planoEmpresarialCheck":false},{"planoEmpresarialCheck":null}],'
    }
    if(tipo == "SERVIDOR"){
      tipos = '"$or":[{"planoFisicoCheck":false},{"planoFisicoCheck":null}],"$or":[{"planoEmpresarialCheck":false},{"planoEmpresarialCheck":null}],'
    }
    if(tipo == "EMPRESARIAL"){
      tipos = '"$or":[{"planoEmpresarialCheck":false},{"planoEmpresarialCheck":null}],"planoEmpresarialCheck":true,'
    }
    if(tipo == ""){
      tipos = ""
    }
    if(situacaoPlanosComb && situacaoPlanosComb.length > 0 && situacaoPlanosComb != "TODOS"){
      sitPlano = JSON.stringify(situacaoPlanosComb);
      buscaSituacao = '"situacao":{"$in":'+sitPlano+'},'
    }
    return this.http.get(this.apiAssociados+'?filtro={'+tipos+buscaSituacao+subs+emps+'"dataAdesao":{"$gte":"'+dtI+'","$lte":"'+dtF+'"},"nome":{"$regex":"'+titular+'","$options":"i"}}&project={"matricula":1,"nome":1,"cpf":1,"dataAdesao":1,"plano":1,"subContrato":1,"planoFisicoCheck":1,"planoEmpresarialCheck":1,"totalMensalidade":1}&limit=' + limit + '&skip=' + skip)
  }

  getAssociadosByTipoPlanoMkt(tipoPlano:any){
    let consulta = "";
    if(tipoPlano == "TODOS" || tipoPlano == ""){
      consulta = "";
    }
    if(tipoPlano == "PLANO FISICO"){
      consulta = '"planoFisicoCheck":true,';
    }
    if(tipoPlano == "PLANO EMPRESARIAL"){
      consulta = '"planoEmpresarialCheck":true,';
    }
    if(tipoPlano == "PLANO SERVIDOR"){
      consulta = '"$or":[{"planoEmpresarialCheck":false},{"planoEmpresarialCheck":null}],"$or":[{"planoFisicoCheck":false},{"planoFisicoCheck":null}],';
    }
    return this.http.get(this.apiAssociados+'?filtro={'+consulta+'"$or":[{"situacao":"ATIVO"},{"situacao":"ALTERAÇÃO"}]}&sort={"nome":1}');
  }

  getTokenDoc() {
    return this.http.post(this.apiDoc24 + "/authDoc24", {});
  }
  
  cadastroUsuario(dados:any){
    let body = JSON.stringify(dados);
    return this.http.post(this.apiUsuarios,body)
  }

   cadastroFornecedor(dados:any){
    let body = JSON.stringify(dados);
    return this.http.post(this.apiFornecedores,body)
  }

  cadastroFavorecido(dados:any){
    let body = JSON.stringify(dados);
    return this.http.post(this.apiFavorecidos,body)
  }

   postComissao(dados:any){
    let body = JSON.stringify(dados);
    return this.http.post(this.apiComissoes,body)
  }

   postProgramacao(dados:any){
    let body = JSON.stringify(dados);
    return this.http.post(this.apiProgramacao,body);
  }

  postCentroCusto(dados:any){
    let body = JSON.stringify(dados);
    return this.http.post(this.apiCentroCusto,body);
  }

   postCredenciado(dados:any){
    let body = JSON.stringify(dados);
    return this.http.post(this.apiCredenciados,body);
  }

  postEmpresa(dados:any){
    let body = JSON.stringify(dados);
    return this.http.post(this.apiEmpresas,body);
  }

  postFinanceiro(dados:any){
    let body = JSON.stringify(dados);
    return this.http.post(this.apiFinanceiro,body);
  }

  cadastroProposta(dados:any){
    let body = JSON.stringify(dados);
    return this.http.post(this.apiAssociados,body);
  }

  postLogsProgramacao(dados:any){
    let body = JSON.stringify(dados);
    return this.http.post(this.apiProgramacaoLogs,body);
  }

  postSubContratos(dados:any){
    let body = JSON.stringify(dados);
    return this.http.post(this.apiSubContratos,body);
  }

  postPlanos(dados:any){
    let body = JSON.stringify(dados);
    return this.http.post(this.apiPlanos,body);
  }

  postLogs(dados:any){
    let body = JSON.stringify(dados);
    return this.http.post(this.apiLogs,body);
  }

  postFaturamento(dados:any){
    let body = JSON.stringify(dados);
    return this.http.post(this.apiFaturamento,body)
  }

  cadastrarVenda(dados:any){
    let body = JSON.stringify(dados);
    return this.http.post(this.apiVendas,body);
  }

  postTags(id:any,dados:any){
    let body = JSON.stringify(dados);
    return this.http.post(this.apiConfiguracoes+'/'+id+'/tags',body);
   }

   postNomesNegociacao(id:any,dados:any){
    let body = JSON.stringify(dados);
    return this.http.post(this.apiConfiguracoes+'/'+id+'/nomesNegociacao',body);
   }

   postBanco(id:any,dados:any){
    let body = JSON.stringify(dados);
    return this.http.post(this.apiConfiguracoes+'/'+id+'/bancos',body);
   }

   newHistorico(id:any,dados:any){
    let body = JSON.stringify(dados);
    return this.http.post(this.apiAssociados+'/'+id+'/historicos',body);
  }

  postSorteioConfiguracoes(id:any,dados:any){
    let body = JSON.stringify(dados);
    return this.http.post(this.apiConfiguracoes+'/'+id+'/sorteios',body);
  }

  postObservacaoUser(id:any,dados:any){
    let body = JSON.stringify(dados);
    return this.http.post(this.apiUsuarios+'/'+id+'/observacao',body);
  }

  newAgendamento(id:any,dados:any){
    let body = JSON.stringify(dados);
    return this.http.post(this.apiAssociados+'/'+id+'/agendamentos',body);
  }

  novaVenda(id:any,dados:any){
    let body = JSON.stringify(dados);
    return this.http.post(this.apiUsuarios+'/'+id+'/vendas',body);
  }

  postHistoricoSinistro(id:any,idSinistro:any,dados:any){
    let body = JSON.stringify(dados);
    return this.http.post(this.apiAssociados+'/'+id+'/sinistro/'+idSinistro+'/historicos',body);
  }
  
  postHistoricoSinistroTitular(id:any,dados:any){
    let body = JSON.stringify(dados);
    return this.http.post(this.apiAssociados+'/'+id+'/sinistro/historicos',body);
  }

  newObservacao(id:any,dados:any){
    let body = JSON.stringify(dados);
    return this.http.post(this.apiSubContratos+'/'+id+'/observacoes',body);
  }

  postTarefa(dados:any){
    let body = JSON.stringify(dados);
    return this.http.post(this.apiUsuarios+'/'+dados.idResponsavel+'/tarefas',body);
  }

  postAviso(id:any,dados:any){
    let body = JSON.stringify(dados);
    return this.http.post(this.apiUsuarios+'/'+id+'/avisos',body);
  }
  
 postDoc24(token: any, dados: any) {
   let obj = {
     token,
     payload: dados
   };
   let body = JSON.stringify(obj);
   return this.http.post(this.apiDoc24 + "/eligibilidad", body);
 }

patchVenda(id:any,dados:any){
  let body = JSON.stringify(dados);
  return this.http.patch(this.apiVendas+'/'+id,body);
}

cadastrarSinistro(id:any, dados:any){
  let body = JSON.stringify(dados);
  return this.http.patch(this.apiAssociados+'/'+id,body)
}

atualizarSinistro(id:any, idSinistro:any, dados:any){
  let body = JSON.stringify(dados);
  return this.http.patch(this.apiAssociados+'/'+id+'/sinistro/'+idSinistro,body)
}

patchSubContratos(id:any,dados:any){
  let body = JSON.stringify(dados);
  return this.http.patch(this.apiSubContratos+'/'+id,body);
}

patchAgendamento(id:any, idAgendamento:any, dados:any){
  let body = JSON.stringify(dados);
  return this.http.patch(this.apiAssociados+'/'+id+'/agendamentos/'+idAgendamento,body);
}

patchPlanos(id:any,dados:any){
  let body = JSON.stringify(dados);
  return this.http.patch(this.apiPlanos+'/'+id,body);
}

patchAssociado(id:any,dados:any){
  let body = JSON.stringify(dados);
  return this.http.patch(this.apiAssociados+'/'+id,body);
}

 patchConfiguracoes(id:any,dados:any){
  let body = JSON.stringify(dados);
  return this.http.patch(this.apiConfiguracoes+'/'+id,body)
}

patchDependentes(id:any,dados:any){
let body = JSON.stringify(dados);
return this.http.patch(this.apiAssociados+'/'+id,body)
}

editarContaFinanceiro(id:any,dados:any){
  let body = JSON.stringify(dados);
  return this.http.patch(this.apiFinanceiro+'/'+id,body)
}

patchCredenciado(id:any,dados:any){
  let body = JSON.stringify(dados);
  return this.http.patch(this.apiCredenciados+'/'+id,body)
}

patchAviso(idUser:any,idAviso:any,dados:any){
  let body = JSON.stringify(dados);
  return this.http.patch(this.apiUsuarios+'/'+idUser+'/avisos/'+idAviso,body);
}

patchTarefa(idUser:any,idTarefa:any,dados:any){
  let body = JSON.stringify(dados);
  return this.http.patch(this.apiUsuarios+'/'+idUser+'/tarefas/'+idTarefa,body);
}

patchEmpresa(id:any,dados:any){
  let body = JSON.stringify(dados);
  return this.http.patch(this.apiEmpresas+'/'+id,body)
}

  patchSorte(id:any,dados:any){
    let body = JSON.stringify(dados);
    return this.http.patch(this.apiSorte+'/'+id,body)
  }
  editarFavorecido(id:any,dados:any){
    let body = JSON.stringify(dados);
    return this.http.patch(this.apiFavorecidos+'/'+id,body)
  }
  
  patchUsuario(id:any,dados:any){
    let body = JSON.stringify(dados);
    return this.http.patch(this.apiUsuarios+'/'+id,body)
  }

  editarFornecedor(id:any,dados:any){
    let body = JSON.stringify(dados);
    return this.http.patch(this.apiFornecedores+'/'+id,body)
  }

  patchCargos(id:any,dados:any){
    let body = JSON.stringify(dados);
    return this.http.patch(this.apiCargos+'/'+id,body)
  }

  patchProgramacao(id:any,dados:any){
    let body = JSON.stringify(dados);
    return this.http.patch(this.apiProgramacao+'/'+id,body)
  }
  
  patchProgramacaoAdm(id:any,dados:any){
    let body = JSON.stringify({administrativo:dados});
    return this.http.patch(this.apiProgramacao+'/'+id,body)
  }

  patchProgramacaoCom(id:any,dados:any){
    let body = JSON.stringify({comercial:dados});
    return this.http.patch(this.apiProgramacao+'/'+id,body)
  }

  patchProgramacaoPub(id:any,dados:any){
    let body = JSON.stringify({publicidade:dados});
    return this.http.patch(this.apiProgramacao+'/'+id,body)
  }

  patchCentroCusto(id:any,dados:any){
    let body = JSON.stringify(dados);
    return this.http.patch(this.apiCentroCusto+'/'+id,body)
  }

  patchFaturamento(id:any,idFaturamento:any,dados:any){
    let body = JSON.stringify(dados);
    return this.http.patch(this.apiFaturamento+'/'+id+'/faturamentos/'+idFaturamento,body);
  }
  
 /*  verificar
  envioPush(arn,msg,titulo){
    let objRequest = {
      tipo:"usuario",
      arn:arn,
      titulo:titulo,
      mensagem:msg
    }
    let body = JSON.stringify(objRequest);
    return this.http.get(this.apiPush+'?body='+body);
} 

  envioPushMassa(msg,titulo){
    let dados = {
      tipo:"topico",
      arn:"",
      titulo:titulo,
      mensagem:msg
    }
    let body = JSON.stringify(dados);
    return this.http.get(this.apiPush+'?body='+body);
  }*/
  

  // DELETE
  delDoc24(token: string, cpf: string) {
    return this.http.request('DELETE', `${this.apiDoc24}/eligibilidad/${cpf}`, {
      body: { token },
      headers: { 'Content-Type': 'application/json' }
    });
  }
  
  removeSinistroAssociadoDB(id:any, idSinistro:any, idDoc:any){
    return this.http.delete(this.apiAssociados+'/'+id+'/sinistro/'+idSinistro+'/documentos'+idDoc);
  }

  removeDocSinistroTitularDB(id:any, idDoc:any){
    return this.http.delete(this.apiAssociados+'/'+id+'/sinistro/documentos/'+idDoc);
  }

  deleteAgenda(id:any, idAgenda:any){
    return this.http.delete(this.apiAssociados+'/'+id+'/agendamentos/'+idAgenda);
   }

  removeDocUsuarioDB(id:any, idDoc:any){
    return this.http.delete(this.apiUsuarios+'/'+id+'/documentos/'+idDoc);
  }

  removeDocVendaDB(id:any,idVenda:any, idDoc:any,){
    return this.http.delete(this.apiUsuarios+'/'+id+'/vendas/'+idVenda+'/anexos/'+idDoc);
  }

  deleteVendaDB(id:any,idVenda:any){
    return this.http.delete(this.apiUsuarios+'/'+id+'/vendas/'+idVenda);
  }

  removeDocSubContratoDB(id:any, idDoc:any){
    return this.http.delete(this.apiSubContratos+'/'+id+'/documentos/'+idDoc);
  }

  removeDocAssociadoDB(id:any, idDoc:any){
    return this.http.delete(this.apiAssociados+'/'+id+'/documentos/'+idDoc);
  }

  removeDocCancelamento(id:any, idDoc:any){
    return this.http.delete(this.apiAssociados+'/'+id+'/documentosCancelamento/'+idDoc);
  }
  
  deleteAssociado(id:any){
    return this.http.delete(this.apiAssociados+'/'+id);
   }
 
   deleteFavorecido(id:any){
     return this.http.delete(this.apiFavorecidos+'/'+id);
    }
 
   deleteSubContratos(id:any){
     return this.http.delete(this.apiSubContratos+'/'+id);
   }
 
   deletePlano(id:any){
     return this.http.delete(this.apiPlanos+'/'+id);
   }
 
   deleteFaturamento(id:any,idFaturamento:any){
     return this.http.delete(this.apiFaturamento+'/'+id+'/faturamentos/'+idFaturamento);
    }
 
   deleteNomesNegociacao(id:any,idNome:any){
     return this.http.delete(this.apiConfiguracoes+'/'+id+'/nomesNegociacao/'+idNome);
    }
 
   deleteTag(id:any,idTag:any){
    return this.http.delete(this.apiConfiguracoes+'/'+id+'/tags/'+idTag);
  }
 
   deleteBanco(id:any,idBanco:any){
    return this.http.delete(this.apiConfiguracoes+'/'+id+'/bancos/'+idBanco);
    }
 
   removeDocConta(id:any, idDoc:any){
     return this.http.delete(this.apiFinanceiro+'/'+id+'/anexos/'+idDoc);
   }
 
   removeDocCredenciado(id:any, idDoc:any){
    return this.http.delete(this.apiCredenciados+'/'+id+'/anexos/'+idDoc);
  }
 
   removeDocEmpresa(id:any, idDoc:any){
    return this.http.delete(this.apiEmpresas+'/'+id+'/anexos/'+idDoc);
   }
 
   deleteContaOrcamentaria(id:any){
     return this.http.delete(this.apiCentroCusto+'/'+id);
    }
 
   deleteUsuario(id:any){
     return this.http.delete(this.apiUsuarios+'/'+id);
    }
 
    deleteContaFinanceiro(id:any){
     return this.http.delete(this.apiFinanceiro+'/'+id);
    }
 
    deleteFornecedor(id:any){
     return this.http.delete(this.apiFornecedores+'/'+id);
    }
 
    deleteCredenciado(id:any){
     return this.http.delete(this.apiCredenciados+'/'+id);
    }
 
    deleteEmpresa(id:any){
     return this.http.delete(this.apiEmpresas+'/'+id);
    } 

    deleteTarefa(idUser:any,idTarefa:any){
      return this.http.delete(this.apiUsuarios+'/'+idUser+'/tarefas/'+idTarefa);
    }
  
}